const faqs = [
  {
    q: '每日大赛mrds是什么平台？',
    a: '每日大赛mrds是一个聚合mrds热门话题与每日爆料的娱乐内容平台，每日更新最新鲜的\u201C新瓜\u201D，涵盖榜单揭晓、黑料深扒和擦边搞笑等多元内容，让你一站式掌握全网热点。',
  },
  {
    q: '榜单数据多久更新一次？',
    a: '我们的榜单每日实时更新，紧跟大赛每日更新的节奏。热度数据、话题排名和爆料进展都会在第一时间刷新，确保你看到的都是最新鲜的榜单看点。',
  },
  {
    q: '如何获取最新的每日爆料？',
    a: '你可以直接访问mrds首页浏览最新内容，也可以关注我们的社交媒体账号获取推送通知。所有mrds每日爆料都会在首页的\u201C最新快讯\u201D板块实时呈现。',
  },
  {
    q: '平台上的内容可靠吗？',
    a: '我们致力于为用户提供高质量的娱乐内容，所有爆料和榜单信息均经过团队初步核实。但娱乐内容仅供消遣参考，具体事实请以官方信息为准。',
  },
];

export default function FaqSection() {
  return (
    <section id="faq" className="py-14 md:py-20 px-4 md:px-6 bg-background-100">
      <div className="max-w-3xl mx-auto">
        <h2 className="text-2xl md:text-3xl font-heading text-foreground-900 mb-10 text-center">
          常见问答
        </h2>
        <div className="space-y-4">
          {faqs.map((faq, i) => (
            <details key={i} className="group bg-background-50 rounded-xl overflow-hidden">
              <summary className="flex items-center justify-between cursor-pointer p-5 md:p-6 list-none">
                <h3 className="text-base md:text-lg font-medium text-foreground-900 pr-4">{faq.q}</h3>
                <div className="w-6 h-6 flex-shrink-0 flex items-center justify-center rounded-full bg-primary-100 text-primary-600 group-open:bg-primary-500 group-open:text-background-50 transition-colors duration-200">
                  <i className="ri-arrow-down-s-line text-lg group-open:rotate-180 transition-transform duration-200"></i>
                </div>
              </summary>
              <div className="px-5 md:px-6 pb-5 md:pb-6">
                <p className="text-sm text-foreground-600 leading-relaxed">{faq.a}</p>
              </div>
            </details>
          ))}
        </div>
      </div>
    </section>
  );
}